import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/button';

const pricingData = [
  { type: '1 BHK', area: '434 - 474 Sq.Ft.', price: '₹ 43 - 46 Lacs*' },
  { type: '2 BHK', area: '663 - 717 Sq.Ft.', price: '₹ 64 - 68 Lacs*' },
];

export default function Pricing({ onEnquireClick }) {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="py-10 sm:py-12 md:py-16 bg-white lg:mr-72 xl:mr-80"
    >
      <div className="max-w-5xl mx-auto px-4">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8 sm:mb-10"
        >
          <h2 className="font-serif text-xl sm:text-2xl md:text-3xl text-[#9A7B4F] mb-2">
            Sai Sun City at Upper Kharghar - Area & Pricing
          </h2>
          <div className="w-12 sm:w-16 h-1 bg-[#9A7B4F] mx-auto" />
        </motion.div>

        {/* Pricing Table */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto overflow-x-auto"
        >
          {/* Table Header */}
          <div className="grid grid-cols-4 bg-[#9A7B4F] text-white min-w-[500px]">
            <div className="p-3 sm:p-4 font-semibold text-xs sm:text-sm">Type</div>
            <div className="p-3 sm:p-4 font-semibold text-xs sm:text-sm">Area</div>
            <div className="p-3 sm:p-4 font-semibold text-xs sm:text-sm">Price (++ Taxes)</div>
            <div className="p-3 sm:p-4"></div>
          </div>

          {/* Table Rows */}
          {pricingData.map((item, index) => (
            <div 
              key={item.type}
              className={`grid grid-cols-4 items-center border-b border-gray-200 min-w-[500px] ${
                index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
              }`}
            >
              <div className="p-3 sm:p-4 text-gray-800 font-medium text-xs sm:text-sm">{item.type}</div>
              <div className="p-3 sm:p-4 text-gray-600 text-xs sm:text-sm">{item.area}</div>
              <div className="p-3 sm:p-4 text-gray-800 font-medium text-xs sm:text-sm">{item.price}</div>
              <div className="p-3 sm:p-4">
                <Button
                  onClick={onEnquireClick}
                  className="bg-[#9A7B4F] hover:bg-[#8A6B3F] text-white rounded-none px-2 sm:px-4 py-1.5 sm:py-2 text-[10px] sm:text-xs font-semibold whitespace-nowrap"
                >
                  <span className="hidden sm:inline">Complete Costing Details</span>
                  <span className="sm:hidden">Get Details</span>
                </Button>
              </div>
            </div>
          ))}
        </motion.div>

        {/* Disclaimer */}
        <p className="text-center text-[10px] sm:text-xs text-gray-400 mt-4 sm:mt-6">
          *Prices are exclusive of taxes and registration charges. Subject to change without prior notice.
        </p>
      </div>
    </section>
  );
}
